pensionService.$inject = ['$http', 'apiBase', '$q']

function pensionService ($http, apiBase, $q) {
  var endpointPath = apiBase + 'v1/pension'

  function endpoint (endPath) {
    if (endPath) {
      return endpointPath + '/' + endPath
    } else {
      return endpointPath
    }
  }

  function calculateContribution (data) {
    var deferred = $q.defer()

    $http({
      url: endpoint('dps/calc/contribution'),
      method: 'POST',
      timeout: deferred.promise,
      cancel: deferred,
      data: data
    }).then(function (result) {
      deferred.resolve(result)
    }, function (error) {
      deferred.reject(error)
    })
    return deferred.promise
  }

  function calculatePensionSavings (data) {
    var deferred = $q.defer()

    $http({
      url: endpoint('dps/calc/savings'),
      method: 'POST',
      timeout: deferred.promise,
      cancel: deferred,
      data: data
    }).then(function (result) {
      deferred.resolve(result)
    }, function (error) {
      deferred.reject(error)
    })
    return deferred.promise
  }

  function fundHistory (fundId, params) {
    var deferred = $q.defer()

    $http({
      url: endpoint('dps/funds/' + fundId + '/yield'),
      method: 'GET',
      cache: true,
      timeout: deferred.promise,
      cancel: deferred,
      params: params,
      name: 'fundHistory'
    }).then(function (result) {
      deferred.resolve(result)
    }, function (error) {
      deferred.reject(error)
    })
    return deferred.promise
  }

  function getParams () {
    var deferred = $q.defer()

    $http({
      url: endpoint('dps/calc/parameters'),
      method: 'GET',
      timeout: deferred.promise,
      cancel: deferred
    }).then(function (result) {
      deferred.resolve(result)
    }, function (error) {
      deferred.reject(error)
    })
    return deferred.promise
  }

  function getTaxSavings (participantSavings, participantMonthContribution, taxRate, minTaxFreeContribution, maxTaxFreeContribution) {
    var temp = (participantSavings / participantMonthContribution) * taxRate
    var min1 = (maxTaxFreeContribution - minTaxFreeContribution) * temp
    var min2

    if (participantMonthContribution > minTaxFreeContribution && participantMonthContribution <= maxTaxFreeContribution) {
      min2 = (participantMonthContribution - minTaxFreeContribution) * temp
    } else if (participantMonthContribution > maxTaxFreeContribution) {
      min2 = min1
    } else {
      min2 = 0
    }

    return Math.floor(Math.min(min1, min2))
  }

  function calculatePensionSavingsWithTax (params) {
    var data = {
      retirementAgeCalculate: params.retirementAgeCalculate,
      yearOfBirth: params.yearOfBirth,
      monthOfBirth: params.monthOfBirth,
      gender: params.gender,
      riskTypeId: params.riskTypeId,
      participantMonthlyContribution: params.participantMonthlyContribution,
      employerMonthlyContribution: params.employerMonthlyContribution,
      fundStrategy: params.fundStrategy
    }
    return calculatePensionSavings(data).then(function (res) {
      res.data.taxSavings = getTaxSavings(
        res.data.participantContribution,
        params.participantMonthlyContribution,
        params.taxRate,
        params.taxMinFreeContribution,
        params.taxMaxFreeContribution
      )
      return res
    })
  }

  function getChildPensionSavings (params) {
    var data = {
      yearOfBirth: params.yearOfBirth,
      monthOfBirth: params.monthOfBirth,
      gender: params.gender,
      riskTypeId: params.riskTypeId,
      participantMonthlyContribution: params.participantMonthlyContribution,
      employerMonthlyContribution: params.employerMonthlyContribution,
      fundStrategy: params.fundStrategy,
      earnings: params.earnings,
      initialDeposit: params.initialDeposit,
      savingStartDate: params.savingStartDate
    }
    return calculateChildSavings(data)
  }

  function calculateChildSavings (data) {
    var eighteen = 18

    var getInvestementHorizon = function (yearBirth, monthBirth, savingStartDate, eighteen) {
      return (yearBirth + eighteen - savingStartDate.getFullYear()) * 12 + (monthBirth - savingStartDate.getMonth() - 1)
    }

    var getTotalAmount = function (investHorizon, earnings, stateContr, monthCont, empContr, initialDeposit) {
      return ((Math.pow(1 + earnings, investHorizon / 12) - 1) / earnings) * (((monthCont + empContr) / 2) * (24 + 12 * earnings) + (1.5 * earnings * stateContr * 3) + (4 * 3 * stateContr)) +
             (initialDeposit * Math.pow(1 + earnings, investHorizon / 12))
    }

    var getStateContribution = function (monthContr) {
      var s = 0
      if (monthContr >= 300) {
        s = (90 + 0.2 * (monthContr - 300))
      }
      if (monthContr >= 999) {
        s = 230
      }
      return s
    }

    var getTotalContributionAmount = function (monthContr, investHorizon, initialDeposit) {
      return monthContr * investHorizon + initialDeposit
    }

    var getTotalEmpContributionAmount = function (empContr, investHorizon) {
      return empContr * investHorizon
    }

    var getTotalStateContributionAmount = function (stateContr, investHorizon) {
      return stateContr * investHorizon
    }

    var getTotalEarnings = function (totalAmount, totalContrAmount, totalEmpAmount, totalStateAmount) {
      return totalAmount - totalContrAmount - totalEmpAmount - totalStateAmount
    }

    var getEighteenAmount = function (totalContrAmount, totalStateAmount, totalEarnings) {
      return (1 / 3) * (totalContrAmount + totalStateAmount + totalEarnings) - (1 / 3) * totalStateAmount
    }

    var stateContribion = getStateContribution(data.participantMonthlyContribution)
    var investHorizon = getInvestementHorizon(data.yearOfBirth, data.monthOfBirth, data.savingStartDate || new Date(), eighteen)
    var totalAmount = getTotalAmount(investHorizon, data.earnings, stateContribion, data.participantMonthlyContribution, data.employerMonthlyContribution, data.initialDeposit || 0)
    var totalContrAmount = getTotalContributionAmount(data.participantMonthlyContribution, investHorizon, data.initialDeposit || 0)
    var totalEmpContrAmount = getTotalEmpContributionAmount(data.employerMonthlyContribution, investHorizon)
    var totalStateContrAmount = getTotalStateContributionAmount(stateContribion, investHorizon)
    var totalEarnings = getTotalEarnings(totalAmount, totalContrAmount, totalEmpContrAmount, totalStateContrAmount)
    var eighteenAmount = getEighteenAmount(totalContrAmount, totalStateContrAmount, totalEarnings)

    var result = {
      stateContribion: stateContribion,
      investHorizon: investHorizon,
      totalAmount: totalAmount,
      totalContrAmount: totalContrAmount,
      totalEmpContrAmount: totalEmpContrAmount,
      totalStateContrAmount: totalStateContrAmount,
      totalEarnings: totalEarnings,
      eighteenAmount: eighteenAmount
    }

    return result
  }

  function chartData (fundId, type, from) {
    return $http({
      url: endpoint('dps/funds/' + fundId + '/holding'),
      method: 'GET',
      params: { type: type, from: from }
    })
  }

  function transformedFundChartData (type) {
    return $http({
      url: endpoint('pp/funds/tf/holding'),
      method: 'GET',
      params: { type: type }
    })
  }

  function portfolio (fundId) {
    return $http({
      url: endpoint('dps/funds/' + fundId + '/portfolio'),
      method: 'GET'
    })
  }

  function transformedFundPortfolio () {
    return $http({
      url: endpoint('pp/funds/tf/portfolio'),
      method: 'GET'
    })
  }

  return {
    calculateContribution: calculateContribution,
    calculatePensionSavings: calculatePensionSavings,
    getTaxSavings: getTaxSavings,
    calculatePensionSavingsWithTax: calculatePensionSavingsWithTax,
    getParams: getParams,
    getChildPensionSavings: getChildPensionSavings,
    fundHistory: fundHistory,
    chartData: chartData,
    transformedFundChartData: transformedFundChartData,
    portfolio: portfolio,
    transformedFundPortfolio: transformedFundPortfolio
  }
}

exports.pensionService = pensionService
